export const TOOL = {
  CROP: 'crop',
  FADE: 'fade',
  PAINT_BUCKET: 'paint-bucket',
  PAINT_BRUSH: 'magic-eraser',
  REPLACE_COLOR: 'replace-color',
  HUE_SATURATION: 'hue-saturation',
  AI: 'ai',
}

export const TOOL_CANVAS_ID = {
  [TOOL.CROP]: 'crop-canvas',
  [TOOL.FADE]: 'fadeToolCanvas',
  [TOOL.PAINT_BUCKET]: 'painbucket-canvas',
  [TOOL.PAINT_BRUSH]: 'magick-eraser-canvas',
  [TOOL.REPLACE_COLOR]: 'replace-color-canvas',
  [TOOL.HUE_SATURATION]: 'hue-saturation-canvas',
  [TOOL.AI]: 'ai-edit-canvas',
}
